import { State } from '../../application/Store'

export const listMeta = (state: State) => state.user.meta
